/**
 * debounce function
 * @param  {[type]} object [description]
 */

interface debounceParams {
  delay: number;
  func: Function;
  timeout: number | null;
  updateTimeout: Function;
  params?: any[];
}

export const useDebounce = ({
  delay,
  func,
  timeout,
  updateTimeout,
  params
}: debounceParams) => {
  if (timeout !== null) {
    clearTimeout(timeout);
    updateTimeout(
      setTimeout(() => {
        if (params) {
          func(...params);
        } else {
          func();
        }
        updateTimeout(0);
      }, delay)
    );
  }
};
